import { useEffect, useRef } from 'react';
import { useMQTT } from '../context/MQTTContext';



const useMQTTClient = (currentUser) => {
  const { connectStatus, mqttData, mqttConnect, mqttSub, mqttUnSub, mqttDisconnect } = useMQTT();
  const isConnectedRef = useRef(false); // Track connection state

  useEffect(() => {
    if (currentUser && !isConnectedRef.current) {
      const url = 'wss://w20135bc.ala.us-east-1.emqxsl.com:8084/mqtt';
      const mqttOption = {
        clientId: `mqtt_${currentUser.username}_${Math.random().toString(16).substr(2, 8)}`,
        username: process.env.REACT_APP_MQTT_USERNAME,
        password: process.env.REACT_APP_MQTT_PASSWORD,
        keepalive: 10,
        clean: true,
        protocol: 'wss', 
        rejectUnauthorized: true,
      };

      mqttConnect(url, mqttOption);
      console.log('Connecting to MQTT broker...');
      isConnectedRef.current = true; // Mark as connected

      const subscription = { topic: 'Beacons', qos: 0 };
      mqttSub(subscription);

      return () => {
        mqttUnSub(subscription);
        mqttDisconnect();
        isConnectedRef.current = false; // Reset connection state
      };
    }
  }, [currentUser, mqttConnect, mqttSub, mqttUnSub, mqttDisconnect]);

  return { connectStatus, mqttData };
};

export default useMQTTClient;
